import { Config } from '../config/config.es6';
import gsap from 'gsap';
import Confetti from './top/confetti.es6';

export default class TopView {
    constructor() {
        this.confetti = new Confetti();
        this.main = document.querySelector('.js-main');
        this.startBtn = document.querySelector('.js-startbtn');
        this.totalCountDisplay = document.querySelector('.js-totalcountdisplay');
        this.mainCountDisplay = document.querySelector('.js-maincountdisplay');
        this.rewardBtns = [...document.querySelectorAll('.js-rewardbtn')];
        this.tapBtn = document.querySelector('.js-tapbtn');
        this.rewardModals = [...document.querySelectorAll('.js-rewardmodal')];

        this.tlBtn = gsap.timeline({ paused: true });
        this.tlKani = gsap.timeline({ paused: true });

        this.tl1 = gsap.timeline({ paused: true });
        this.tl2 = gsap.timeline({ paused: true });
        this.tl3 = gsap.timeline({ paused: true });

        this.tl10000Achivement = gsap.timeline({ paused: true });

        // アニメーション中かどうかを示すフラグ
        this.isAnimating = false;

        this._btnAnimation();
        this._kaniAnimation();
        this._phase1Animation();
        this._phase2Animation();
        this._phase3Animation();
        this._10000AchivementAnimation();
    }

    setPageReady() {
        this.main.classList.add('-ready');
    }

    setAchievementCount(achievementCount) {
        this.main.setAttribute('data-achievementcount', achievementCount);
    }

    displayCount(num, digits, display) {
        let tag = '';
        //ゼロパディング
        ('00000' + num)
            .slice(-digits)
            .split('')
            .forEach(function (val) {
                tag += `<span>${val}</span>`;
            });
        display.innerHTML = tag;
    }

    activeRewardBtns(elm, isActiveReward) {
        if (isActiveReward) {
            elm.classList.add('-active');
        }
    }

    insertActiveReward(elm, isActiveReward, rewardPath) {
        if (isActiveReward) {
            elm.querySelector('.js-rewardcontent').setAttribute('src', rewardPath);
        }
    }

    insertYoutubeID(isActiveReward, youtubeID) {
        const elm = document.querySelector(`.js-rewardbtn[data-reward="${Config.ACHIVEMENT_COUNT.length}"]`);
        if (elm && isActiveReward) {
            elm.setAttribute('data-videoID', youtubeID);
        }
    }

    setAnimating(isAnimating) {
        this.isAnimating = isAnimating;
    }

    _btnAnimation() {
        this.tlBtn.to('.tapbtn', { duration: 0.2, scale: 0.9, ease: 'power3.in' }, 0);
        this.tlBtn.to('.tapbtn', { duration: 2.5, scale: 1, ease: 'elastic.out(1, 0.3)' }, '+=0');
    }

    _kaniAnimation() {
        this.tlKani.to('.kani__leg.-l.-leg1', { duration: 0.4, rotate: 20, x: '3%', ease: 'steps(2)', yoyo: true, repeat: 5 }, '<');
        this.tlKani.to('.kani__leg.-r.-leg1', { duration: 0.4, rotate: 20, x: '-3%', ease: 'steps(2)', yoyo: true, repeat: 5 }, '<');
        this.tlKani.to('.kani__leg.-l.-leg2, .kani__leg.-l.-leg3, .kani__leg.-l.-leg4', { duration: 0.4, rotate: -10, x: '3%', ease: 'steps(2)', yoyo: true, repeat: 5 }, '<');
        this.tlKani.to('.kani__leg.-r.-leg2, .kani__leg.-r.-leg3, .kani__leg.-r.-leg4', { duration: 0.4, rotate: 10, x: '-3%', ease: 'steps(2)', yoyo: true, repeat: 5 }, '<');
        this.tlKani.call();
    }

    _phase1Animation() {
        this.tl1.set('.kani__eye.-l .sumi', { scale: 1.2 });

        this.tl1.to('.kani__eye.-l', { duration: 0.4, scale: 1.5, ease: 'power3.in' }, 0);
        this.tl1.to('.kani__eye.-l .sumi', { duration: 0.4, opacity: 1 }, '+=0');
        this.tl1.to('.kani__eye.-l .sumi', { duration: 0.4, scale: 1 }, '<');
        this.tl1.to('.kani__eye.-l .sumi', { duration: 0.8, opacity: 0 }, '+=1');
        this.tl1.to('.kani__eye.-l', { duration: 1, scale: 1, ease: 'power3.out' }, '<');
    }

    _phase2Animation() {
        this.tl2.set('.kani__eye.-r .sumi', { scale: 1.2 });

        this.tl2.to('.kani__eye.-r', { duration: 0.4, scale: 1.5, ease: 'power3.in' }, 0);
        this.tl2.to('.kani__eye.-r .sumi', { duration: 0.4, opacity: 1 }, '+=0');
        this.tl2.to('.kani__eye.-r .sumi', { duration: 0.4, scale: 1 }, '<');
        this.tl2.to('.kani__eye.-r .sumi', { duration: 0.8, opacity: 0 }, '+=1');
        this.tl2.to('.kani__eye.-r', { duration: 1, scale: 1, ease: 'power3.out' }, '<');
    }

    _phase3Animation() {
        this.tl3.set('.kani__eye .sumi', { scale: 1.2 });

        this.tl3.to('.kani__eye .medama', { duration: 0.4, opacity: 0 }, 0);
        this.tl3.to('.kani__eye', { duration: 0.4, scale: 1.5, ease: 'power3.in' }, '<');
        this.tl3.to('.kani__eye .sumi', { duration: 0.4, opacity: 1 }, '+=0');
        this.tl3.to('.kani__eye .sumi', { duration: 0.4, scale: 1 }, '<');
        this.tl3.to('.kani__eye .sumi', { duration: 0.8, opacity: 0 }, '+=1');
        this.tl3.to('.kani__eye .medama', { duration: 0.4, opacity: 1 }, '<');
        this.tl3.to('.kani__eye', { duration: 1, scale: 1, ease: 'power3.out' }, '<');
    }

    tapAnimation(achevementCount) {
        this.tlBtn.restart();

        // ボタン以外はthis.isAnimatingフラグがfalseの時のみ実行する
        if (this.isAnimating) return;

        this.setAnimating(true);
        this.tlKani.eventCallback('onComplete', () => this.setAnimating(false));
        this.tlKani.restart();

        // タイムラインを最初から再生する
        if (achevementCount === 0) {
            this.tl1.restart();
        } else if (achevementCount === 1) {
            this.tl2.restart();
        } else if (achevementCount === 2) {
            this.tl3.restart();
        }
    }

    show10000Achivement() {
        this.tl10000Achivement.restart();
    }

    _10000AchivementAnimation() {
        this.tl10000Achivement.set('.maincounter__10000achivement .txt', { opacity: 0, scale: 1.5 });
        this.tl10000Achivement.set('.maincounter__10000achivement .bg', { opacity: 0 });

        this.tl10000Achivement.to('.maincounter__10000achivement .txt', { duration: 2, opacity: 1, scale: 1, ease: 'elastic.out(1,0.3)' }, 0.3);
        this.tl10000Achivement.to('.maincounter__10000achivement .bg', { duration: 0.6, opacity: 1 }, 0.8);
    }
}
